<template>
  <div class="map-info">
    <button id="close-button" class="btn btn-outline-dark btn-close" @click="onCloseButtonClick"> × </button>
    <div v-if="searchActive === false && currentTown.id" id="town-selected">
      <h2> {{ currentTown.name }}</h2>
      <div class="state">{{ stateName }}</div>
      <div class="wrapper">
        <div class="municipality">{{ municipalityName }}</div>
        <div class="label" >{{ $t("municipality") }}</div>
      </div>
      <div class="heading">{{ $t("producers") }}:</div>
      <div class="producer-container" v-for="producer in displayedProducers" v-bind:key="producer.id" @click="navigateToProducer(producer)">
        <h4 class="producer-name">{{ producer.name }}</h4>
        <img class="link-arrow" src="@/assets/images/arrow-right.svg" />
      </div>
    </div>
    <div v-if="searchActive === true" id="map-search">
      <b-form>
        <b-form-group id="input-group-1" :label="fermenterTypeLabel" label-for="input-1">
          <b-form-select id="input-1"  v-model="filterCriteria.fermenterType" @change="onFilterChanged">
            <b-form-select-option :value="null">{{ $t("selectOne") }}</b-form-select-option>
            <b-form-select-option v-for="fermenter in fermenterDropDownData" v-bind:key="fermenter.id" :value="fermenter.id">{{ fermenter.name }}</b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-2" :label="stillTypeLabel" label-for="input-2">
          <b-form-select id="input-2" v-model="filterCriteria.stillType" @change="onFilterChanged">
            <b-form-select-option :value="null">{{ $t("selectOne") }}</b-form-select-option>
            <b-form-select-option v-for="still in stillDropDownData" v-bind:key="still.id" :value="still.id">{{ still.name }}</b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-3" :label="brandNameLabel" label-for="input-3">
          <b-form-select id="input-3" v-model="filterCriteria.brandName" @change="onFilterChanged">
            <b-form-select-option :value="null">{{ $t("selectOne") }}</b-form-select-option>
            <b-form-select-option v-for="brand in brandDropDownData" v-bind:key="brand.id" :value="brand.id">{{ brand.name }}</b-form-select-option>
          </b-form-select>
        </b-form-group>        
        <b-button id="reset-button" type="reset" @click="resetFilters">{{ $t("reset") }}</b-button>
      </b-form>
    </div>
  </div>
  
</template>

<script>

export default {
  name: 'MapInfo',
  components: {

  },
  computed: {
    currentTown() {
      return this.$store.state.currentTown;
    },
    fermenterTypeLabel(){
      if (this.$i18n.i18next.language === 'en'){
        return 'Fermenter Type:'
      } else {
        return 'Tina de Fermentación:'
      }
    },
    stillTypeLabel(){
      if (this.$i18n.i18next.language === 'en'){
        return 'Still Type:'
      } else {
        return 'Tipo de Alambique:'
      }
    },
    brandNameLabel(){
      if (this.$i18n.i18next.language === 'en'){
        return 'Brands:'
      } else {
        return 'Marcas:'
      }
    }


  },
  async mounted(){
    this.setupData();
    if (this.municipalities.length === 0){
      setTimeout(this.setupData, 1153)
    }
    if (this.$store.state.currentTown.id){
      this.updateInfoDrawer(this.$store.state.currentTown);
      this.filterProducers();
    }
  },
  props: {
    searchActive: Boolean,
    fermenterDropDownData: Array,
    stillDropDownData: Array,
    brandDropDownData: Array,
    filteredProducers: Array
  },
  data () {
    return {
      displayedProducers: [],
      municipalityName: "",
      regionName: "",
      stateName: "",
      municipalities: [],
      states: [],
      filterCriteria: {
        stillType: null,
        fermenterType: null,
        brandName: null,
        filterActive: false,
      }

    }
  },
  methods: {
    async setupData(){
      this.municipalities = await this.$getItem('municipalities');
      this.states = await this.$getItem('states');
    },
    onCloseButtonClick(){
      this.$emit('drawer-close');
    },
    onFilterChanged(){
      if (this.filterCriteria.stillType || this.filterCriteria.fermenterType || this.filterCriteria.brandName){
        this.filterCriteria.filterActive = true;
      }
      this.$emit('filter-change',this.filterCriteria);
    },
    resetFilters(){
      this.filterCriteria.stillType = null;
      this.filterCriteria.fermenterType = null;
      this.filterCriteria.brandName = null;
      this.filterCriteria.filterActive = false;
      this.onFilterChanged();
    },
    filterProducers(){
      this.displayedProducers = this.filteredProducers.filter(producer => producer.town_id === this.currentTown.id)
    },
    updateInfoDrawer(newValue){
      const municipality = this.municipalities.find(muni => muni.id === newValue.municipality_id);
      this.municipalityName = municipality.name;
      this.regionName = municipality.region;

      const matchingState = this.states.find(state => state.id === municipality.state_id);
      this.stateName = matchingState.name;
    },
    navigateToProducer(producer){
      this.$router.push({ name: 'Producer', query: { id: producer.id, setName: 'producers' }});
    }
    

  },
  watch: {
    currentTown(newValue) {
      this.updateInfoDrawer(newValue);
      this.filterProducers();
    },
    filteredProducers(){
      this.filterProducers();
    },
  }
}
</script>

<style lang="scss" scoped>

h2 {
  margin-right: 32px;
}

h4 {
  font-family: 'avenir';
}

.map-info {
  height: 100%;
  padding: 10px;
}

.state {
  margin-top: -5px;
  margin-bottom: 10px;
  color: grey;
}

.municipality {
  font-size: 1.5rem;
}

.wrapper {
    display: inline-block;
}

.label {
  margin-top: -7px;
  float: right;
  font-size: 14px;
  color: grey;
}

.heading {
  margin-top: 15px;
  font-family: 'optima';
  font-size: 18px;
  font-weight: 100;
  color: grey;
}

.producer-container{
  margin-left: 10px;
}

.producer-name{
  display: inline-block;
}

.link-arrow {
  height: 12px;
  margin-left: 5px;
  margin-bottom: 8px;
}

#map-search {
  padding-top: 15px;
}

#close-button {
  position: absolute;
  left: calc(100vw - 40px);
  margin-top: -3px;
}

#reset-button {
  margin-top: 5px;
}

</style>
